// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const gatherHeader = "GatherHeader__gatherHeader__VpF5K";
export const progress = "GatherHeader__progress__jdATz";
export const title = "GatherHeader__title__HSgLR";
export const subtitleWrapper = "GatherHeader__subtitleWrapper__38vY1";